import { TmcContextService } from './../../../../../common/tmc-context.service';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TranslationService } from '@sdbn/common';
import { TransportOption } from '../../../../../client/model/transport-option';


@Component({
    selector: 'app-transport-option-gc-connection-dialog',
    templateUrl: './transport-option-gc-connection-dialog.component.html',
    styleUrls: ['./transport-option-gc-connection-dialog.component.scss'],
    standalone: false
})
export class TransportOptionGcConnectionDialogComponent implements OnInit, OnDestroy {

  qrCodeUrl: string;

  public optionsWithCase = new Array<TransportOption>();

  private contextSubscription: Subscription;

  optionSelectionFormGroup = new FormGroup({});

  constructor(
    public dialogRef: MatDialogRef<TransportOptionGcConnectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private tmcContextService: TmcContextService,
    public translationService: TranslationService
  ) {

    this.optionSelectionFormGroup.addControl('option', new FormControl('', []));
    this.optionSelectionFormGroup.valueChanges.subscribe(
      values => {
        const selectedOption: TransportOption = this.optionSelectionFormGroup.controls.option.value;
        this.qrCodeUrl = selectedOption.messagingReference;
      }
    );

    this.contextSubscription = this.tmcContextService.updated.subscribe(
      yardConfig => {
        if (yardConfig != null) {
          const validTransportOptions = new Array<TransportOption>();
          for (const to of yardConfig.transportOptions) {
            if (to.messagingReference != null && to.messagingReference.length > 0) {
              validTransportOptions.push(to);
              if (to.transportOptions != null) {
                for (const child of to.transportOptions) {
                  if (child.messagingReference != null && child.messagingReference.length > 0) {
                    validTransportOptions.push(child);
                  }
                }
              }
            }
          }
          this.optionsWithCase = validTransportOptions;
          this.optionSelectionFormGroup.reset({ option: this.optionsWithCase[0] });
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.contextSubscription != null) {
      this.contextSubscription.unsubscribe();
      this.contextSubscription = null;
    }
  }

  ngOnInit(): void {
  }

  public closeDialog() {
    this.dialogRef.close();
  }

}
